<template>
  <div
    :title="params.name == null ? params.displayName : params.name"
    class="subscribableheader__title"
  >
    <div v-if="params.name == null">
      {{ params.displayName }}
    </div>
    <div
      v-else
      class="link"
      @click="openLink"
      v-safe-html="renderDiv()"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { EXAM, SINGLE } from '@/constants'

export default Vue.extend({
  name: 'SubscribableHeader',

  data () {
    return {
      params: null,
    }
  },

  methods: {
    openLink () {
      window.open(this.params.link)
    },

    renderDiv () {
      let title = `<span style="color: #b71c1c">${_.escape(this.params.name)}</span>`

      if (this.params.type === SINGLE || this.params.type === EXAM) {
        let subscribable = Object.values(this.$store.state.subscribables.subscribables).find(subscribable => subscribable.id === this.params.id)

        let eventId = null
        if (this.params.type === SINGLE) {
          eventId = subscribable.event
        } else {
          // Name of exam events is the same, so we take the first one
          eventId = subscribable.examEvents[0]
        }

        let eventObject = Object.values(this.$store.state.events.events).find(event => event.id === eventId)

        let date = moment(eventObject.starttime).format('DD-MM HH:mm')

        return title + `<br> <small style="font-style:italic; font-weight:normal">${date}</small>`
      }

      return title
    },
  },
})
</script>

<style lang="scss">
    .subscribableheader__title {
      font-size: 14px;
      padding: 0px;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
      cursor: pointer;

        .link {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
</style>
